import CompanySerialNumberAssignDialog from './company-assign-sn-dialog.container';

export default CompanySerialNumberAssignDialog;
